/* eslint-disable max-len */
import React from 'react';

interface IQuestionProps {
    color?: string;
}

const Question: React.FC<IQuestionProps> = ({color = '#899696'}) => {

    return (
        <svg
            width="16"
            height="16"
            viewBox="-1 -1 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5Z"
                stroke={color}
            />
            <path
                d="M4.66699 5.11467C4.66699 3.85204 5.71555 2.91663 7.00005 2.91663C8.30205 2.91663 9.33366 3.94708 9.33366 5.24996C9.33366 6.09521 8.49717 7.17204 7.51017 7.58329V8.02136C7.51017 8.15666 7.45643 8.28641 7.36076 8.38208C7.26509 8.47774 7.13534 8.53149 7.00005 8.53149C6.86475 8.53149 6.735 8.47774 6.63933 8.38208C6.54367 8.28641 6.48992 8.15666 6.48992 8.02136V7.22892C6.48996 7.12182 6.5237 7.01746 6.58636 6.93061C6.64902 6.84377 6.73743 6.77884 6.83905 6.74504C7.6738 6.46679 8.31341 5.67083 8.31341 5.24996C8.31341 4.51058 7.73942 3.93688 7.00005 3.93688C6.28517 3.93688 5.68724 4.40942 5.68724 5.11467C5.68724 5.24996 5.6335 5.37971 5.53783 5.47538C5.44216 5.57105 5.31241 5.62479 5.17712 5.62479C5.04182 5.62479 4.91207 5.57105 4.8164 5.47538C4.72074 5.37971 4.66699 5.24996 4.66699 5.11467Z"
                fill={color}
            />
            <path
                d="M7.61872 9.58966C7.45462 9.42556 7.23206 9.33337 7 9.33337C6.76794 9.33337 6.54538 9.42556 6.38128 9.58966C6.21719 9.75375 6.125 9.97631 6.125 10.2084C6.125 10.4404 6.21719 10.663 6.38128 10.8271C6.54538 10.9912 6.76794 11.0834 7 11.0834C7.23206 11.0834 7.45462 10.9912 7.61872 10.8271C7.78281 10.663 7.875 10.4404 7.875 10.2084C7.875 9.97631 7.78281 9.75375 7.61872 9.58966Z"
                fill={color}
            />
        </svg>

    );
};

export default Question;
